import { getLanguageTag } from '@vista/omnichannel-components-domain';
import { MemberContactMethod, MemberMailerFrequency } from '@vista-digital/ocapi-types/v1';
export const mapMemberFormDataToPreferences = (memberFormData) => {
    const { primarySite, favouriteGenres, newsletter, allowThirdPartyContact, allowThirdPartyProfiling } = memberFormData;
    return {
        sites: {
            preferredSiteIds: [],
            primarySiteId: primarySite || undefined
        },
        genres: {
            preferredGenreIds: favouriteGenres
        },
        contact: {
            contactMethods: newsletter ? [MemberContactMethod.Email] : [],
            mailerFrequency: newsletter ? MemberMailerFrequency.Weekly : MemberMailerFrequency.Never,
            allowThirdPartyContact
        },
        allowThirdPartyProfiling,
        customPreferences: [],
        languageTag: getLanguageTag()
    };
};
